import { render, staticRenderFns } from "./IconLogoBig.vue?vue&type=template&id=8860161a&"
import script from "./IconLogoBig.vue?vue&type=script&lang=js&"
export * from "./IconLogoBig.vue?vue&type=script&lang=js&"
import style0 from "./IconLogoBig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports